export {default} from './Text';
